import React, { useState } from 'react';
import { Form, Button, Alert } from 'react-bootstrap';
import { API_BASE_URL } from '../config/api';
import { getValidToken } from '../utils/tokenManager';
import { normalizeSignupPhone } from '../utils/normalizeSignupPhone';

export default function ConnectRentalAccount({ onConnected }) {
  const [phone, setPhone] = useState('');
  const [code, setCode] = useState('');
  const [challengeId, setChallengeId] = useState(null);
  const [linked, setLinked] = useState(false);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState(null);

  const post = async (action, body) => {
    const token = await getValidToken();
    if (!token) throw new Error('Your session expired. Please sign in again.');
    const response = await fetch(`${API_BASE_URL}/auth/phone-link/${action}`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
      body: JSON.stringify(body),
    });
    const result = await response.json();
    if (!response.ok) throw new Error(typeof result.error === 'string' ? result.error : 'Could not verify your phone. Please try again.');
    return result;
  };

  const submit = async e => {
    e.preventDefault();
    setBusy(true);
    setError(null);
    try {
      if (linked) {
        await onConnected();
      } else if (!challengeId) {
        const result = await post('request', { phone: normalizeSignupPhone(phone) });
        setChallengeId(result.challengeId);
      } else {
        await post('confirm', { challengeId, code: code.trim() });
        setLinked(true);
        await onConnected();
      }
    } catch (err) {
      setError(err.message || 'Could not connect your rental account');
    } finally { setBusy(false); }
  };

  return <section className="tg-card tg-card-pad tg-link-card">
    <h2>Link your rental account</h2>
    <p>Verify the phone number on your rental agreement to access your rentals, balance, and payment history. Each login can link to one rental account at a time.</p>
    <Form onSubmit={submit}>
      {!challengeId ? <Form.Group className="mb-3" controlId="rentalPhone">
        <Form.Label>Rental phone number</Form.Label>
        <Form.Control type="tel" name="phone" autoComplete="tel" value={phone} onChange={e => setPhone(e.target.value)} required disabled={busy} />
        <Form.Text>We’ll text a six-digit verification code to this number. Message and data rates may apply.</Form.Text>
      </Form.Group> : !linked ? <Form.Group className="mb-3" controlId="rentalPhoneCode">
        <Form.Label>SMS verification code</Form.Label>
        <p>Enter the code sent to {phone}. It expires in 10 minutes.</p>
        <Form.Control inputMode="numeric" pattern="[0-9]{6}" maxLength={6} autoComplete="one-time-code" value={code} onChange={e => setCode(e.target.value)} required disabled={busy} />
      </Form.Group> : null}
      {error && <Alert variant="danger">{error}</Alert>}
      <Button type="submit" disabled={busy}>{busy ? 'Please wait…' : linked ? 'Open my dashboard' : challengeId ? 'Verify and link rental account' : 'Send verification code'}</Button>
      {challengeId && !linked && <Button variant="link" disabled={busy} onClick={() => { setChallengeId(null); setCode(''); setError(null); }}>Change phone or resend code</Button>}
    </Form>
  </section>;
}
